import { CloseSolidIcon } from '@pmi/dsm-react/dist/components/icons';
import { memo } from 'react';
import RenderHtml from '../../../../../../shared/components/RenderHtml';
import { benefitsItems } from '../../../../../../shared/constants';
import styles from '../enhancedEnrollmentModal.module.scss';

interface BenefitsPanelProps {
  productName: string;
  onCancel: () => void;
}

function BenefitsPanel({ productName, onCancel }: BenefitsPanelProps) {
  return (
    <div className={styles.benefitsContainer}>
      <div className="d-flex justify-content-between align-items-center">
        <RenderHtml
          html={`Your ${productName} Benefits`}
          tag="span"
          className={styles.customHeader}
        />
        <div>
          <CloseSolidIcon className="cursor-pointer" onClick={onCancel} />
        </div>
      </div>
      <hr className="my-4" />
      <div className={styles.benefitsIntro}>
        Get ready to unlock PMI member exclusives:
      </div>

      <div className={styles.benefitsList}>
        {benefitsItems.map((benefit, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <div key={index}>
            <span className="me-2">•</span>{' '}
            {/* Manual bullet for better control */}
            <RenderHtml html={benefit} tag="span" />
          </div>
        ))}
      </div>
    </div>
  );
}

export default memo(BenefitsPanel);
